<template>
  <b-sidebar bg-variant="white" id="leads-sidebar" no-header right shadow>
    <div class="px-3 py-2">
      <i class="fas fa-close position-absolute" v-b-toggle.leads-sidebar></i>
      <div class="p-3 mt-3">
        <img src="/img/integrations/fub-logo.png" class="w-100 mb-2 integration-logo" />
      </div>
      <leads></leads>
    </div>
  </b-sidebar>
</template>

<script>
import Leads from '@/views/Components/FUB/Leads';

export default {
  components: {
    Leads
  }
};
</script>